import { lazyGetSelectedTeamsCalendars } from 'owa-calendarsapi-teams-calendars';
import { isFeatureEnabled } from 'owa-feature-flags';
import { PerformanceDatapoint, DatapointStatus } from 'owa-analytics';

export async function initializeSelectedTeamsCalendars(refresh?: boolean) {
    const datapoint = new PerformanceDatapoint('initializeSelectedTeamsCalendars');
    refresh = true;

    const featureEnabled = isFeatureEnabled('cal-showAddTeamsCalendars');
    /*const initialLoad = getSelectedTeamsCalendars(); TODO implement initial load WI 63507*/
    const issueServiceCall = featureEnabled && refresh; // || initialLoad);

    datapoint.addCustomData({
        issueServiceCall,
        featureEnabled,
        refresh,
    });

    try {
        if (issueServiceCall) {
            await lazyGetSelectedTeamsCalendars.importAndExecute();
        }
        datapoint.end();
    } catch (error) {
        datapoint.endWithError(DatapointStatus.ServerError, Error(error));
        throw error;
    }
}
